import { makeVar } from '@apollo/client';
import type { EditableCallback, GridState } from '@cmg/data-grid';
import { getColDefId } from '@cmg/data-grid';

import { RolodexRecordStatus } from '../../../../../../../graphql';
import { relationshipStatusColDef } from './columns/relationship-status';
import type { FirmSalesCoverageGridItemFragment } from './graphql/__generated__';

export const refetchFirmsSalesCoverageGridReactiveVar = makeVar(false);

export type FirmSalesCoverageGridContext = {
  isRelationshipStatusEditable: boolean;
};

export const isRelationshipStatusColumnEditable: EditableCallback<
  FirmSalesCoverageGridItemFragment,
  unknown,
  FirmSalesCoverageGridContext
> = ({ context }) => context.isRelationshipStatusEditable;

export function canInvestorFirmEditCoverageRelationshipStatus(
  firmStatus: RolodexRecordStatus
): boolean {
  return firmStatus !== RolodexRecordStatus.Deleted;
}
export const INITIAL_INVESTOR_SALES_COVERAGE_GRID_STATE: GridState = {
  filter: {
    filterModel: {
      [getColDefId(relationshipStatusColDef)]: {
        values: [RolodexRecordStatus.Effective],
        filterType: 'set',
      },
    },
  },
};
